import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ScienceSection } from '../components/ScienceSection';
import { BundleSection } from '../components/BundleSection';
import { EaseSection } from '../components/EaseSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-sage" data-id="element-513">
      <AnnouncementBar data-id="element-514" />
      <HeroSection data-id="element-515" />
      <PainSection data-id="element-516" />
      <ScienceSection data-id="element-517" />
      <BundleSection data-id="element-518" />
      <EaseSection data-id="element-519" />
      <SocialProofSection data-id="element-520" />
      <PricingSection data-id="element-521" />
      <TestimonialsSection data-id="element-522" />
      <FAQSection data-id="element-523" />
      <Footer data-id="element-524" />
    </div>;
}